import styled from "styled-components";
import { MOBILE_WIDTH } from "../../constants";

export const AboutPageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  @media ${MOBILE_WIDTH} {
    flex-direction: column;
    justify-content: space-around;
  }
`;

export const AboutInfoContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 32px;
  max-width: 700px;

  @media ${MOBILE_WIDTH} {
    text-align: center;
    align-items: center;
    padding: 16px;
  }
`;

export const AboutText = styled.p`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  margin: 0;
  margin-top: 16px;
`;

export const AboutImage = styled.img`
  max-height: 400px;
  padding: 32px;
  @media ${MOBILE_WIDTH} {
    padding: 16px;
    max-height: 100%;
    width: calc(100% - 32px);
    max-width: 500px;
  }
`;
